// extracted by mini-css-extract-plugin
module.exports = {"Mongolia_Data_Form_Field_Wrapper":"MongoliaDataDetail_Mongolia_Data_Form_Field_Wrapper__1escT"};